import axios from 'axios'
import i18n from '@/locale'
import router from '@/router'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers['X-Language'] = i18n.locale
axios.defaults.headers['Accept-Language'] = i18n.locale

axios.interceptors.response.use(
  response => response,
  (error = {}) => {
    const { status } = error.response || {}

    const isForbidden = [401].includes(status)

    if (isForbidden) {
      localStorage.removeItem('Token')
      router.push({ name: 'login' })
    } else {
      return Promise.reject(error)
    }
  }
)

const airports = {
  all: () => axios.get('/flight/airports'),
  getByString: text => axios.get(`/flight/airports?searchString=${text}`)
}

const airlines = {
  all: () => axios.get('/flight/airlines'),
  getByString: text => axios.get(`/flight/airlines?searchString=${text}`, {})
}

const fields = {
  all: lang =>
    axios.get('/flight/dicts', {
      headers: {
        'X-Language': lang,
        'Accept-Language': lang
      }
    })
}

const compensation = {
  calc: paramsData =>
    axios.get('/flight/calcRecompensation', {
      params: paramsData
    })
}

const login = {
  token: data => axios.post('/musketeer/token', data)
}

const flights = {
  collect: params => axios.get('/musketeer/flights', { params: params }),
  byId: id => axios.get(`/musketeer/flights/${id}`),
  complaintLite: (data, lang) =>
    axios.post('/musketeer/complaint-lite', data, {
      headers: {
        'X-Language': lang
      }
    })
}

export default {
  airlines,
  airports,
  fields,
  compensation,
  login,
  flights
}
